module.exports = __webpack_public_path__ + "static/contact-background-mobile_2-0a6d43e2f7387c56057a1dd711ba4093.jpg";